/* headerColors.js — the per-affiliate palettes.
 *
 * Data only. Two consumers read these maps and neither is allowed to write
 * here:
 *   assets/sts-chrome.js           v4
 *   assets/header-color-change.js  the legacy templates
 *
 * WHAT THEY PAINT changed on 2026-09-19. Until then the affiliate colour won
 * the header bar, the footer bar and every primary CTA, and the skin-type
 * colour kept the accents. Luis's call, after looking at ?code=DRB rendered:
 * partner identity carries on the LOGO, and the chrome — header band, nav row,
 * footer bar — and the CTAs keep the STS navy on a co-branded page, exactly as
 * an unbranded visit gets them. What still says who the partner is: the logo
 * swap in the header, the provider band lower down, and the partner's own
 * announcement messages.
 *
 * So both consumers now paint an OPT-IN set — elements carrying
 * data-sts-affiliate-paint="header", "footer" or "button", which take the
 * matching map below — and nothing in the theme carries the attribute today.
 * These maps are still live data, still measured, and still the place a
 * partner's colours are defined; they simply no longer recolour the interface
 * by themselves. The provider band is the surface they are most likely to be
 * pointed at next.
 *
 * Adding an affiliate still means adding it to all three maps; a code present
 * in one and missing from another gives a partner a half-dressed page wherever
 * these are opted in, which is how DRB looked before this note existed.
 *
 * `color` and `hoverColor` are a REQUEST, not the final ink. Every entry below
 * asks for white, and measured against the backgrounds beside them most of
 * those pairs are under WCAG AA 4.5:1 — the three footers sit at 1.48:1, 1.92:1
 * and 1.96:1, which is not readable text. Both consumers therefore measure the
 * background against white and against black (WCAG 2.x relative luminance, in
 * assets/sts-chrome.js as window.STS.contrast) and paint whichever reads,
 * keeping the declared colour whenever it already clears AA. So a new partner's
 * `background` is the value that matters here; `color` is honoured where it
 * works and corrected where it does not. The chosen ink and the ratio behind it
 * land on the element as data-sts-ink / data-sts-contrast and in
 * window.STS.affiliateContrast, and a palette that fails against BOTH white and
 * black is listed in its `unreadable` array and warned about in the console —
 * that one is a merchandising fix here, not a theme fix.
 *
 * That report's `failing` array is a different and stricter thing: the text
 * NODES measured on these surfaces that come in under AA. A background whose
 * ink clears AA can still carry a muted link class that does not, so `failing`
 * is the list to read before calling a partner page readable.
 */

// headerColorChanges
window.headerColors = {
  'DRB': { background: '#948984', color: 'white' },
  'RT202': { background: '#000000', color: 'white' },
  'AAC': { background: '#d2a852', color: 'white' }
};

//Primary Color Change, Text, and Hover
window.buttonColors = {
  'DRB': {
    background: '#948984',
    color: 'white',
    hoverBackground: '#7a726d',
    hoverColor: '#ffffff'
  },
  'RT202': {
    background: '#000000',
    color: 'white',
    hoverBackground: '#333333',
    hoverColor: '#ffffff'
  },
  'AAC': {
    background: '#d2a852',
    color: 'white',
    hoverBackground: '#b68b42',
    hoverColor: '#ffffff'
  }
};


// Footer Color Change and Text
window.footerColors = {
  'DRB': {
    background: '#bcbbb9',
    color: 'white',
  },
  'RT202': {
    background: '#d4d4d4',
    color: 'white',
  },
  'AAC': {
    background: '#d5b485',
    color: 'white',
  }
};